/* Mente Sucia · Home 2026 — interacciones ligeras (tabs, carruseles, agregar al carro) */
(function () {
  'use strict';

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    root.querySelectorAll('[data-ms-tabs]').forEach(function (group) {
      if (group.dataset.msReady) return;
      group.dataset.msReady = '1';
      var tabs = Array.prototype.slice.call(group.querySelectorAll('[role="tab"]'));
      var scope = group.closest('[data-ms-tabs-scope]') || document;
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = scope.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        scope.querySelectorAll('[data-ms-tab-link]').forEach(function (a) {
          if (tab.dataset.url) a.setAttribute('href', tab.dataset.url);
          var lbl = a.querySelector('[data-ms-tab-link-label]');
          if (lbl && tab.dataset.urlLabel) lbl.textContent = tab.dataset.urlLabel;
        });
        if (focus) tab.focus();
        var panelEl = scope.querySelector('#' + tab.getAttribute('aria-controls'));
        if (panelEl) updateRails(panelEl);
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  /* ---------- Carruseles ---------- */
  function updateRail(rail) {
    var track = rail.querySelector('[data-ms-track]');
    if (!track) return;
    var prev = rail.querySelector('[data-ms-prev]');
    var next = rail.querySelector('[data-ms-next]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }
  function updateRails(root) {
    root.querySelectorAll('[data-ms-rail]').forEach(updateRail);
  }
  function initRails(root) {
    root.querySelectorAll('[data-ms-rail]').forEach(function (rail) {
      if (rail.dataset.msReady) return;
      rail.dataset.msReady = '1';
      var track = rail.querySelector('[data-ms-track]');
      if (!track) return;
      var step = function () { return Math.max(track.clientWidth * 0.85, 200); };
      var prev = rail.querySelector('[data-ms-prev]');
      var next = rail.querySelector('[data-ms-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      var sync = function () { updateRail(rail); };
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = document.querySelector('.ms-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ms-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    el.innerHTML = '<span></span><a href="' + root + 'cart">Ver carro</a>';
    el.firstChild.textContent = msg;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3800);
  }

  /* ---------- Agregar al carro ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ms-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-ms-add');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var label = btn.querySelector('[data-label]');
    var original = label ? label.textContent : '';
    btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'No se pudo agregar');
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        btn.classList.add('is-added');
        if (label) label.textContent = 'Agregado';
        setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = original; }, 2200);
        try {
          var ev = new Event('cart:update', { bubbles: true });
          ev.detail = { resource: cart, sourceId: 'ms-home', data: { itemCount: cart.item_count, source: 'ms-home', variantId: id } };
          document.dispatchEvent(ev);
        } catch (err) { /* noop */ }
        var drawer = document.querySelector('cart-drawer-component');
        if (!drawer || !drawer.hasAttribute('auto-open')) toast('Producto agregado al carro');
      })
      .catch(function (err) {
        toast(err && err.message ? err.message : 'No se pudo agregar. Intenta desde el producto.');
      })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });

  function init(root) { initTabs(root); initRails(root); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
